import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from './Guards/localstorage.service';
import { LoginServiceService } from './services/api/login-service.service';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  title = 'Billing portal';

  toggle : boolean = false;

  isHttpActive: boolean;
  isLoggedIn =  false;
  isSystemAdmin =  false;
  

  constructor(private comm: CommonService,private _AuthService : AuthService, private _loginService : LoginServiceService,private authService: AuthService, private router: Router, 
    @Inject(LOCAL_STORAGE) private localStorage: Storage) {


    comm.OnInterception().subscribe(
      r => {
        this.isHttpActive = r;
      }
    );

  }

  logout(){
    this._loginService.settoggleview(false);
    this.authService.logout();
  }

  addItem(newItem: boolean) {
   this.toggle = newItem;
  }
  ngOnInit() : void {
    if(this.localStorage.getItem("token") != null){
      this.authService.isUserLoggedIn.next(true);
      this.isLoggedIn = true;
      this._loginService.settoggleview(true);
      this.toggle = true;
      this.router.navigate(['./invoicing/carrier'])

    }

  }

  ngDoCheck(){
    this.toggle = this._loginService.gettoggleview();
  }

}